import axios from 'axios'

// API基础配置
const API_BASE_URL = 'https://chb.hnjsxk.com/modelWorker/modelWorker'

// 创建axios实例
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器 - 自动添加token
apiClient.interceptors.request.use(
  config => {
    const token = localStorage.getItem('chb_token')
    if (token) {
      config.headers['x-access-token'] = token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器 - 统一错误处理
apiClient.interceptors.response.use(
  response => {
    return response
  },
  error => {
    console.error('API请求失败:', error)
    return Promise.reject(error)
  }
)

// API方法封装
export const api = {
  // 获取登录token
  async getToken() {
    try {
      // console.log('正在调用登录接口:', `${API_BASE_URL}/chbWxUser/chbWxUser/login`)
      const response = await axios.post(`${API_BASE_URL}/chbWxUser/chbWxUser/login`)
      // console.log('登录接口响应:', response.data)
      if (response.data && response.data.result.token) {
        const token = response.data.result.token
        localStorage.setItem('chb_token', token)
        // console.log('Token已保存到localStorage:', token)
        return token
      }
      return null
    } catch (error) {
      console.error('获取token失败:', error)
      throw error
    }
  },

  // 检查并获取token
  async checkAndGetToken() {
    let token = localStorage.getItem('chb_token')
    // console.log('当前localStorage中的token:', token)
    if (!token || token == 'undefined' || token == '' || token == null) {
      // console.log('未找到token，准备调用登录接口')
      token = await this.getToken()
    } else {
      // console.log('已找到token，无需重新获取')
    }
    return token
  },

  // 提交需求表单
  async submitDemand(demandData) {
    try {
      await this.checkAndGetToken() // 确保有token
      const response = await apiClient.post('/chbDemand/chbDemand/add', demandData)
      return response.data
    } catch (error) {
      console.error('提交需求失败:', error)
      throw error
    }
  },

  // 获取政策资讯列表
  async getPolicyList(pageNo = 1, pageSize = 50) {
    try {
      await this.checkAndGetToken() // 确保有token
      const response = await apiClient.get(`/chbPolicy/chbPolicy/list?pageNo=${pageNo}&pageSize=${pageSize}&column=createTime&order=desc`)
      return response.data
    } catch (error) {
      console.error('获取政策资讯失败:', error)
      throw error
    }
  },

  // 获取活动发布数据 - zero接口
  async getActivityZero() {
    try {
      await this.checkAndGetToken() // 确保有token
      const response = await apiClient.get('/chbActivity/chbActivity/zero')
      return response.data
    } catch (error) {
      console.error('获取活动发布数据(zero)失败:', error)
      throw error
    }
  },

  // 获取活动发布数据 - one接口
  async getActivityOne() {
    try {
      await this.checkAndGetToken() // 确保有token
      const response = await apiClient.get('/chbActivity/chbActivity/one')
      return response.data
    } catch (error) {
      console.error('获取活动发布数据(one)失败:', error)
      throw error
    }
  },

  // 获取供需数据列表
  async getSupplyDemandList(type) {
    try {
      await this.checkAndGetToken() // 确保有token
      const response = await apiClient.get(`/chbSupply/chbSupply/list?type=${type}`)
      return response.data
    } catch (error) {
      console.error('获取供需数据失败:', error)
      throw error
    }
  }
}

export default api